import { render, staticRenderFns } from "./boundingBox.vue?vue&type=template&id=b8baac82&"
import script from "./boundingBox.vue?vue&type=script&lang=ts&"
export * from "./boundingBox.vue?vue&type=script&lang=ts&"
import style0 from "./boundingBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports